import Slideout from 'slideout';
import $ from "jquery";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import Parallax from 'parallax-js';

import { addLeadingZero } from './utils';

const initParallax = () => {
  var scene = document.getElementById('scene');
  var parallaxInstance = new Parallax(scene, { limitY: 100, limitX: 150, hoverOnly: true });

  return parallaxInstance;
}

const initCarousel = () => {
  const $carouselPrevCounter = $('.hero').find('.nav-prev-counter');
  const $carouselNextCounter = $('.hero').find('.nav-next-counter');

  const carousel = $('.hero-carousel').owlCarousel({
    loop: false,
    items: 1,
    nav: true,
    dots: true,
    margin: 100,
    animateOut: 'fadeOutLeft',
    animateIn: 'fadeInLeft',
    mouseDrag: false,
    touchDrag: false,
    navContainer: '#hero-carousel-nav',
    dotsContainer: '#hero-carousel-dots',
    navText: ['', ''],
    navElement: 'div',
    autoplay: true,
    autoplayTimeout: 10000,
    autoplayHoverPause: true,
  });

  carousel.on('changed.owl.carousel', e => {
    const index = e.item.index + 1;
    const count = e.item.count;
    const prevIndex = (index - 1) > 1 ? index - 1 : 1;
    const nextIndex = (index + 1) < count ? index + 1 : count;
    $carouselPrevCounter.removeClass('disabled').text(addLeadingZero(prevIndex));
    $carouselNextCounter.removeClass('disabled').text(addLeadingZero(nextIndex));

    if (index === 1) {
      $carouselPrevCounter.addClass('disabled');
    }

    if (nextIndex === index) {
      $carouselNextCounter.addClass('disabled');
    }
  });

  $carouselPrevCounter.on('click', (e) => {
    $(e.target).siblings('.owl-prev').click();
  });

  $carouselNextCounter.on('click', (e) => {
    $(e.target).siblings('.owl-next').click();
  });

  return carousel;
}

const intMobileMenu = () => {
  const slideout = new Slideout({
    'panel': document.getElementById('panel'),
    'menu': document.getElementById('menu'),
    'padding': 200,
    'tolerance': 70,
    'side': 'right',
    'touch': false
  });

  [].slice.call(document.getElementsByClassName('toggle-button')).forEach(elem => {
    elem.addEventListener('click', function () {
      slideout.toggle();
    });
  });

  let menu = slideout.menu;
  slideout.menu = slideout.panel;
  slideout.panel = menu;

  return slideout;
};

export const initHero = function () {
  setTimeout(function () {
    document.body.classList.add('loaded');


    setTimeout(function () {
      intMobileMenu();
      initCarousel();
      initParallax();
    }, 1500)
  }, 2000)
};